import React, { useCallback, useEffect, useState } from 'react';
import styled from '@emotion/styled';
import DropdownTable from './DropdownTable';
import debounce from 'lodash.debounce';
import produce from 'immer';
import axios from 'axios';
import qs from 'qs';
import SelectedCityBar from './SelectedCityBar';
import { PropertyForm, SelectedCity } from '../types';
import { XIcon } from '../../../components/icons';

interface Props {
  property?: PropertyForm;
  changePropertyInfo: (label: keyof Partial<PropertyForm>, value: any) => void;
  setPropertyInfo?: (p: any) => void;
  state: any;
}
const Municipality = (props: Props) => {
  const [isDropdown, setIsDropdown] = useState(false);
  const [cityOptions, setCityOptions] = useState<any[]>([]);
  const [cityLoaderStatus, setCityLoaderStatus] = useState(false);
  const [selectedItem, setSelectedItem] = useState(false);
  const baseSelectedCity: SelectedCity = {
    county: '',
    municipality: '',
    municipalityId: null,
    municipalityType: '',
    stateCode: '',
    stateName: '',
    subMunicipality: '',
    subMunicipalityId: null,
    subMunicipalityType: '',
    swisCode: '',
    rpadSwisCode: '',
    countyId: null,
    id: null,
    municipalityTypeId: null,
    subMunicipalityTypeId: null,
    hamletId: null,
    hamletName: '',
  };
  const handleSelectedCity = (item: SelectedCity) => {
    const property: PropertyForm = {
      id: props.property.id,
      address: props.property.address,
      section: props.property.section,
      block: props.property.block,
      lot: props.property.lot,
      owners: props.property.owners,
      qualifier: props.property.qualifier,
      unit:props.property.unit,
      selectedCity: item,
    };
    props.setPropertyInfo(property);
    setIsDropdown(false);
    setSelectedItem(true)
  };

  const getCityOptions = useCallback(
    debounce(async (value, state) => {
      setCityLoaderStatus(true);
      const params = qs.stringify({
        searchValue: value,
        locationTypeId: state.value > 0 ? state.value : null
      })
      const { data } = await axios.get(`/api/clientproperty/GetCityOptions?${params}`);
      setCityOptions(data.filter((d, i) => i < 100));
      setIsDropdown(data.length ? true : false);
      setCityLoaderStatus(false);
    }, 600),
    []
  );
  const deleteMuni = () => {
    props.changePropertyInfo('selectedCity', baseSelectedCity);
  };
  useEffect(() => {
    window.addEventListener('click', () => {
      setIsDropdown(false);
    });
    return () => {
      window.removeEventListener('click', () => {
        setIsDropdown(false);
      });
    };
  }, []);

  return (
    <>
      <div style={{marginTop:16}}>
        <div style={{ paddingBottom: 8 }}>Municipality</div>
        <div style={{ position: 'relative', width: 630 }}>
          {(props.property?.selectedCity?.municipalityId || false) &&
          props.property?.selectedCity?.municipalityId ? (
            <SelectedCityBar city={props.property?.selectedCity} icon={<XIcon onClick={deleteMuni} />} />
          ) : (
            <div>
              <DropdownTable
                name="property.selectedCity.subMunicipalityId"
                label=""
                width="630px"
                isDropdown={isDropdown}
                itemList={cityOptions}
                onTextChange={e => {
                  getCityOptions(e.target.value, props.state);
                  e.stopPropagation();
                }}
                onClick={() => {}}
                onItemClick={e => {
                  handleSelectedCity(e);
                }}
                // onBlur={e => {
                //   if (!selectedItem) {
                //     props.changePropertyInfo('undeterminedLocality', e.target.value);
                //   }
                // }}
                loadingStatus={cityLoaderStatus}
                styles={{ svg: { display: 'none' } }}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Municipality;
